import { render, staticRenderFns } from "./ProfessionList.vue?vue&type=template&id=4e07ad8e&scoped=true&"
import script from "./ProfessionList.vue?vue&type=script&lang=js&"
export * from "./ProfessionList.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionList.vue?vue&type=style&index=0&id=4e07ad8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07ad8e",
  null
  
)

export default component.exports